/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const removeItemTypeAssociationsRequestSchema = z.object({
  itemTypeIds: z.array(z.int()),
});
